const { getElement, waitForConsentSettingsAvailability } = window.BAO.Utils

class PushCartTagalysRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.setupTagalysRecs()

    window.addEventListener('resize', () => {
      this.visibility = this.checkVisibility()
    })

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.onCartChanged,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.onCartChanged,
    )
  }

  setupTagalysRecs () {
    if (window?.onTagalysReady && this.widgetId && this.visibility) {
      this.fetchTagalysRecommendations = this.fetchTagalysRecommendations.bind(
        this,
      )
      // eslint-disable-next-line no-undef
      onTagalysReady(() => {
        waitForConsentSettingsAvailability(() => {
          this.fetchTagalysRecommendations()
        })
      })
    }
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    if (this.dataset.type !== 'SmartWidget') {
      window.tagalysCartRecs = null

      // this.setupTagalysRecs()
    }
  }

  async fetchTagalysRecommendations () {
    if (window.tagalysCartRecs?.length > 0) {
      const cards = await this.createProductCards(window.tagalysCartRecs)
      this.renderCarousel(cards)
    } else {
      try {
        const response = await this.getTagalysRecommendations()
        if (response?.products?.length > 0) {
          window.tagalysCartRecs = response.products
          const cards = await this.createProductCards(response.products)
          this.renderCarousel(cards)
        }
      } catch (error) {
        this.handleError(error)
      }
    }
  }

  getTagalysRecommendations () {
    if (this.dataset.type === 'SmartWidget') {
      return new Promise((resolve, reject) => {
        window.Tagalys.APIConnector[this.dataset.type].call({
          params: {
            widgetId: this.widgetId,
            limit: this.limit,
          },
          onSuccess: response => resolve(response),
          onFailure: error => reject(error),
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        window.Tagalys.APIConnector[this.dataset.type].call({
          params: {
            recommendationId: this.widgetId,
            productId: this.dataset.productId,
            limit: this.limit,
          },
          onSuccess: response => resolve(response),
          onFailure: error => reject(error),
        })
      })
    }
  }

  async createProductCards (products) {
    const cards = await Promise.all(
      products.map(async product => {
        const productUrl = `${window.Shopify.routes.root}products/${product.handle}`

        try {
          const res = await window.BAO.sectionRenderer.fetchSingle(
            'push-cart-recommendations-item',
            productUrl,
          )
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const article = newDOM.querySelector('li')

          return article ? `${article.outerHTML}` : ''
        } catch (error) {
          this.handleError(error)
          return ''
        }
      }),
    )

    return cards.join('')
  }

  renderCarousel (cards) {
    const targetEl = getElement('.psh-Recommendations_Body', { context: this })

    targetEl.innerHTML = `
      <ul class="psh-Recommendations_List">
        ${cards}
      </ul>`
  }

  handleError (error) {
    console.error('Error:', error)
  }

  get limit () {
    return this.dataset.limit || 8
  }

  get widgetId () {
    return this.dataset.widgetId || ''
  }

  get visibility () {
    return this._visibility || this.checkVisibility()
  }

  set visibility (value) {
    if (value !== this._visibility) {
      this.setupTagalysRecs()

      this._visibility = value
    }
  }
}

if (!customElements.get('push-cart-tagalys-recommendations')) {
  customElements.define(
    'push-cart-tagalys-recommendations',
    PushCartTagalysRecommendations,
  )
}
